module.exports = __webpack_public_path__ + "fox.jpg?c65e38b00a6eac1b1c0725fa5a26f6bb";